import React, { ReactElement } from 'react'
import { DiscountLineModel } from './types/models'
import { formatPriceString } from '../../common/helpers/number-formatters'

type DiscountLineProps = {
  line: DiscountLineModel;
}

const DiscountLine = ({ line }: DiscountLineProps): ReactElement => (
  <>
    <hr className="basketDivider" />
    <div className="new-basket-item">
      <div className="discount-line-details basket-item-info">
        {line.name}
      </div>

      <div className="basket-item-unit-price basket-item-info">
        <span className="mobile-only">Unit Price:&nbsp;</span>
        <span className="v-center">{formatPriceString(line.price_without_tax)}</span>
      </div>

      <div className="discount-line-quantity basket-item-info">
        <span className="mobile-only">Quantity:&nbsp;</span>
        <div className="discount-quantity v-center">{line.quantity}</div>
      </div>

      <div className="basket-item-total basket-item-info">
        <span className="mobile-only">Total:&nbsp;</span>
        <span className="v-center">{formatPriceString(line.price_without_tax)}</span>
      </div>
    </div>
  </>
)

export default DiscountLine
